import React, { Component } from "react";
import { connect } from "react-redux";
import { payTransaction } from "../actions";
import { NavLink, Redirect } from "react-router-dom";

class PaymentReceipt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      response: {},
      transactionno: "",
      transactionamount: "",
      transactionmessage: "",
      admissionno: ""
      // isInserted: false
    };
  }

  atomResponse(objresponse) {
    // console.log("objresponse", objresponse);
    if (objresponse.f_code.toLowerCase() !== "c") {
      var configAdmno = objresponse.udf5;
      var payDataref = configAdmno.split("|");
      this.setState({
        transactionno: objresponse.mmp_txn,
        transactionamount: objresponse.amt,
        transactionmessage: objresponse.desc,
        admissionno: payDataref[3]
      });
    }
  }
  payuResponse(objresponse) {
    this.setState({
      transactionno: objresponse.mihpayid,
      transactionamount: objresponse.amount,
      transactionmessage: objresponse.status,
      admissionno: objresponse.udf5
    });
  }
  axisResponse(objresponse) {
    //console.log("objresponse", objresponse);
    var configAdmno = objresponse.vpc_MerchTxnRef;
    var payDataref = configAdmno.split("|");
    this.setState({ response: objresponse, admissionno: payDataref[3] });
    var paymentRes = {
      transactionno: objresponse.vpc_TransactionNo,
      transactionamount: objresponse.vpc_Amount,
      transactionmessage: objresponse.vpc_Message,
      transactionresponse: JSON.stringify(objresponse),
      paymentfor: payDataref[4] == 1 ? "Admission Form Fees" : "Tution Fees",
      paymentfrompath: "",
      admissionno: objresponse.vpc_MerchTxnRef,
      toUpdate: objresponse.vpc_TxnResponseCode == 0 ? 1 : 0
    };
    this.setState({
      transactionno: objresponse.vpc_TransactionNo,
      transactionamount: objresponse.vpc_Amount,
      transactionmessage: objresponse.vpc_Message
    });
    this.props.payTransaction(paymentRes);
  }

  componentDidMount() {
    var search = this.props.location.search.substring(1);
    // console.log("search==", search);
    var objresponse = JSON.parse(
      '{"' +
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    );
    // console.log("objresponse", objresponse);
    if (objresponse.provider && objresponse.provider === "PAYU") {
      this.payuResponse(objresponse);
    } else if (objresponse.provider && objresponse.provider === "AXIS") {
      this.axisResponse(objresponse);
    } else if (objresponse.provider && objresponse.provider === "ATOM") {
      this.atomResponse(objresponse);
    } else {
      this.axisResponse(objresponse);
    }
  }

  render() {
    if (this.props.auth.redirectToLogin && this.props.auth.logOut) {
      return <Redirect exact to="/Login" />;
    }
    return (
      <div className="container d-confirm">
        <div className="confirmationBox">
          <h3 className="page-head-title">Payment Status</h3>
          <p>
            <strong>{"Transaction No."}</strong> : {this.state.transactionno}
          </p>
          <p>
            <strong>{"Admission No."}</strong> : {this.state.admissionno}
          </p>
          <p>
            <strong>{"Message"}</strong> : {this.state.transactionmessage}
          </p>
          <NavLink
            className="btn btn-danger btn-lg theme-btn d-inline"
            to="/Account/StudentAccount/Dashboard"
          >
            <i className="fa fa-angle-left" aria-hidden="true" />
            Back To Dashboard
          </NavLink>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    auth
  };
}
export default connect(
  mapStateToProps,
  {
    payTransaction
  }
)(PaymentReceipt);



// WEBPACK FOOTER //
// ./src/components/PaymentReceipt.js